'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _defineProperty = require('@babel/runtime/helpers/defineProperty');
var _objectWithoutProperties = require('@babel/runtime/helpers/objectWithoutProperties');
var PropTypes = require('prop-types');
var jsxRuntime = require('react/jsx-runtime');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var _defineProperty__default = /*#__PURE__*/_interopDefault(_defineProperty);
var _objectWithoutProperties__default = /*#__PURE__*/_interopDefault(_objectWithoutProperties);
var PropTypes__default = /*#__PURE__*/_interopDefault(PropTypes);

var _excluded = ["title"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty__default.default(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var VisibilityOffIcon = function VisibilityOffIcon(_ref) {
  var _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'VisibilityOff' : _ref$title,
    props = _objectWithoutProperties__default.default(_ref, _excluded);
  return /*#__PURE__*/jsxRuntime.jsxs("svg", _objectSpread(_objectSpread({
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "#000000",
    title: title
  }, props), {}, {
    children: [/*#__PURE__*/jsxRuntime.jsx("title", {
      children: title
    }), /*#__PURE__*/jsxRuntime.jsxs("g", {
      children: [/*#__PURE__*/jsxRuntime.jsx("rect", {
        fill: "none",
        height: "24",
        width: "24"
      }), /*#__PURE__*/jsxRuntime.jsx("path", {
        d: "M8.00033 2.66667C9.84033 2.66667 11.3337 4.16 11.3337 6C11.3337 6.43333 11.247 6.84 11.0937 7.22L13.0403 9.16667C14.047 8.32667 14.8403 7.24 15.327 6C14.1737 3.07333 11.327 1 7.99366 1C7.06033 1 6.16699 1.16667 5.34033 1.46667L6.78033 2.90667C7.16033 2.75333 7.56699 2.66667 8.00033 2.66667ZM1.33366 0.846667L2.85366 2.36667L3.16033 2.67333C2.05366 3.53333 1.18699 4.68 0.666992 6C1.82033 8.92667 4.66699 11 8.00033 11C9.03366 11 10.0203 10.8 10.9203 10.44L11.2003 10.72L13.1537 12.6667L14.0003 11.82L2.18033 0L1.33366 0.846667ZM5.02033 4.53333L6.05366 5.56667C6.02033 5.70667 6.00033 5.85333 6.00033 6C6.00033 7.10667 6.89366 8 8.00033 8C8.14699 8 8.29366 7.98 8.43366 7.94667L9.46699 8.98C9.02033 9.2 8.52699 9.33333 8.00033 9.33333C6.16033 9.33333 4.66699 7.84 4.66699 6C4.66699 5.47333 4.80033 4.98 5.02033 4.53333V4.53333ZM7.89366 4.01333L9.99366 6.11333L10.007 6.00667C10.007 4.9 9.11366 4.00667 8.00699 4.00667L7.89366 4.01333Z"
      })]
    })]
  }));
};
VisibilityOffIcon.propTypes = {
  title: PropTypes__default.default.string
};
VisibilityOffIcon.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "VisibilityOffIcon",
  "props": {
    "title": {
      "defaultValue": {
        "value": "'VisibilityOff'",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    }
  }
};
var VisibilityOffIcon$1 = VisibilityOffIcon;

exports.default = VisibilityOffIcon$1;
//# sourceMappingURL=VisibilityOffIcon.js.map
